import React, {useState} from 'react';
import {useForm} from '@mantine/form';
import {Alert, Anchor, Button, Group, Stack, Text, TextInput} from '@mantine/core';
import {useNavigate} from 'react-router-dom';
import {requestPasswordReset} from '../../api/Auth';
import {useMediaQuery} from "@mantine/hooks";

export function RequestForgottenPassword() {
    const isMobile = useMediaQuery('(max-width: 768px)');
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);
    const [submitting, setSubmitting] = useState(false);

    const form = useForm({
        initialValues: {
            email: '',
        },
        validate: {
            email: (val) => (/^\S+@\S+$/.test(val) ? null : 'Invalid email'),
        },
    });

    const handleRequestReset = async (values: { email: string }) => {
        setSubmitting(true);
        try {
            const result = await requestPasswordReset(values.email);
            if (result.success) {
                console.log("reset password request successfully")
                navigate(`/reset-forgotten-password?email=${encodeURIComponent(values.email)}`);
            } else {
                setError(result.error || 'Failed to send verification code');
            }
        } catch (error) {
            setError('An unexpected error occurred');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <>
            <Text size="xl" fw={500} mb="md">
                Reset Your Password
            </Text>
            <Text size="sm" mb="xl" c="dimmed">
                Enter your email address below and we'll send you a verification code to reset your password.
            </Text>

            {error && (
                <Alert
                    title="Error"
                    color="red"
                    mb="lg"
                    onClose={() => setError(null)}
                    withCloseButton
                >
                    {error}
                </Alert>
            )}

            <form onSubmit={form.onSubmit(handleRequestReset)}>
                <Stack>
                    <TextInput
                        mb={'md'}
                        required
                        label="Email"
                        placeholder="name@mail.com"
                        value={form.values.email}
                        onChange={(event) => form.setFieldValue('email', event.currentTarget.value)}
                        error={form.errors.email}
                        radius="md"
                    />

                    {isMobile ? (
                        <>
                            <Button
                                type="submit"
                                radius="xl"
                                color="blue"
                                loading={submitting}
                                fullWidth
                            >
                                Send Verification Code
                            </Button>
                            <Text size="sm" ta="center" c={'dimmed'}>
                                Remember your password?{' '}
                                <Anchor component="button" type="button" onClick={() => navigate('/login')} c="blue">
                                    Login
                                </Anchor>
                            </Text>
                        </>
                    ) : (
                        <Group justify="space-between">
                            <Text size="sm" c={'dimmed'}>
                                Remember your password?{' '}
                                <Anchor component="button" type="button" onClick={() => navigate('/login')} c="blue">
                                    Login
                                </Anchor>
                            </Text>
                            <Button
                                type="submit"
                                radius="xl"
                                color="blue"
                                loading={submitting}
                            >
                                Send Verification Code
                            </Button>
                        </Group>
                    )}
                </Stack>
            </form>
        </>
    );
}